// Utilitários do Dashboard (§4.1): montagem dos deep-links para a
// Consulta e formatação de números/percentuais dos KPIs e charts.
import { FRONTEND_ROUTES } from "@/constants"

// Subconjunto dos filtros da Consulta usados nos deep-links do
// Dashboard — MESMAS chaves do hook
// use-notification-center-notifications-search-params.
export type NotificationSearchLinkFilters = Partial<
  Record<
    | "startDate"
    | "endDate"
    | "channel"
    | "provider"
    | "status"
    | "event"
    | "scheduled"
    // period=all → "todas as datas" (KPIs snapshot "Em fila"/
    // "Agendados", que não têm recorte de data).
    | "period",
    string
  >
>

// Href para /notification-center/search com os filtros na query
// (URL como estado da Consulta). Valores vazios são omitidos.
export const buildNotificationSearchHref = (
  filters: NotificationSearchLinkFilters = {}
): string => {
  const params = new URLSearchParams()
  Object.entries(filters).forEach(([key, value]) => {
    if (value) params.set(key, value)
  })
  const queryString = params.toString()
  const baseHref =
    FRONTEND_ROUTES.NOTIFICATION_CENTER_SEARCH.href
  return queryString
    ? `${baseHref}?${queryString}`
    : baseHref
}

// Inteiro com separador de milhar do locale (tabular-nums no CSS).
export const formatDashboardInteger = (
  value: number,
  language: string
): string => new Intl.NumberFormat(language).format(value)

// Taxa em fração (0.973) → percentual do locale ("97,3%").
export const formatDashboardRate = (
  value: number,
  language: string
): string =>
  new Intl.NumberFormat(language, {
    style: "percent",
    maximumFractionDigits: 1,
  }).format(value)

// Delta em fração (0.12 / -0.18) → percentual COM sinal
// ("+12%" / "-18%"). null = sem delta (tratado no componente).
export const formatDashboardDelta = (
  delta: number,
  language: string
): string =>
  new Intl.NumberFormat(language, {
    style: "percent",
    maximumFractionDigits: 1,
    signDisplay: "always",
  }).format(delta)
